import React from "react";
import { Container, Row, Col, CardBody, Card } from "reactstrap";
import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//Import Components

//Import Image

import IncomeStats from "./components/IncomeStats";
import PassesPayments from "./components/PassesPayments";
import Users from "./components/Users";
import MostLovedGyms from "./components/MostLovedGyms";
import UserStats from "./components/UserStats";
import GymStats from "./components/GymStats";

import MostVisitedGyms from "./components/MostVisitedGyms";
import Gyms from "./components/Gyms";
import { useSelector } from "react-redux";
import PlaceholderDashboard from "../../../src/assets/Group.svg";

const Dashboard = () => {
  document.title = " Admin Dashboard | Elevated Iron - Admin Dashboard";

  const { userPermissions } = useSelector((state) => state.auth.currentUser);
  return (
    <React.Fragment>
      <div className="mx-2">
        <Row className="gx-2">
          {/* When Gym Permission is Given */}
          {userPermissions?.gym?.["View Gym"] ? (
            <>
              <Col xxl="4" xl="4" lg="6" md="6" sm="12" xs="12">
                <GymStats />
                <MostLovedGyms />
              </Col>
              <Col xxl="4" xl="4" lg="6" md="6" sm="12" xs="12">
                <UserStats />
                <MostVisitedGyms />
              </Col>
              <Col xxl="4" xl="4" md="12" sm="12" xs="12">
                <IncomeStats />
              </Col>

              {/* When both Pass & User permissions exist */}
              {userPermissions?.passes?.["View Pass"] &&
                (userPermissions?.user?.["Active User"] ||
                  userPermissions?.user?.["Block User"] ||
                  userPermissions?.user?.["Archive User"]) && (
                  <>
                    <Col xxl="6" xl="6" lg="12" md="12" sm="12" xs="12">
                      <PassesPayments />
                    </Col>
                    <Col xxl="6" xl="6" lg="12" md="12" sm="12" xs="12">
                      <Users />
                    </Col>
                  </>
                )}

              {/* When only one permission exists in Gym branch */}
              {userPermissions?.passes?.["View Pass"] &&
                !(
                  userPermissions?.user?.["Active User"] ||
                  userPermissions?.user?.["Block User"] ||
                  userPermissions?.user?.["Archive User"]
                ) && (
                  <Col xxl="12" xl="12" lg="12" md="12" sm="12" xs="12">
                    <PassesPayments />
                  </Col>
                )}

              {!userPermissions?.passes?.["View Pass"] &&
                (userPermissions?.user?.["Active User"] ||
                  userPermissions?.user?.["Block User"] ||
                  userPermissions?.user?.["Archive User"]) && (
                  <Col xxl="12" xl="12" lg="12" md="12" sm="12" xs="12">
                    <Users />
                  </Col>
                )}

              <Col
                xxl="12"
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                className="mb-5"
              >
                <Gyms />
              </Col>
            </>
          ) : (
            // When Gym Permission is Missing: Adjust UI so that the replacements take the combined space.
            <>
              {/* If both Pass and User permissions exist, render them in separate columns */}
              {userPermissions?.passes?.["View Pass"] &&
              (userPermissions?.user?.["Active User"] ||
                userPermissions?.user?.["Block User"] ||
                userPermissions?.user?.["Archive User"]) ? (
                <>
                  <Col xxl="4" xl="4" lg="6" md="6" sm="12" xs="12">
                    <GymStats />
                    <PassesPayments />
                  </Col>
                  <Col xxl="4" xl="4" lg="6" md="6" sm="12" xs="12">
                    <GymStats />
                    <Users />
                  </Col>
                </>
              ) : userPermissions?.passes?.["View Pass"] ? (
                // Only Pass permission exists → use one column that takes both positions.
                <Col xxl="8" xl="8" lg="12" md="12" sm="12" xs="12">
                  <GymStats />
                  <PassesPayments />
                </Col>
              ) : userPermissions?.user?.["Active User"] ||
                userPermissions?.user?.["Block User"] ||
                userPermissions?.user?.["Archive User"] ? (
                // Only User permission exists → use one column that takes both positions.
                <Col xxl="8" xl="8" lg="12" md="12" sm="12" xs="12">
                  <GymStats />
                  <Users />
                </Col>
              ) : null}
              {userPermissions?.user?.["Active User"] ||
              userPermissions?.user?.["Block User"] ||
              userPermissions?.user?.["Archive User"] ||
              userPermissions?.passes?.["View Pass"] ||
              userPermissions?.gym?.["View Gym"] ? (
                <Col xxl="4" xl="4" md="12" sm="12" xs="12">
                  <IncomeStats />
                </Col>
              ) : (
                <Col xxl="12" xl="12" md="12" sm="12" xs="12">
                  <Card
                    className="rounded-4 ff-sora d-flex justify-content-center align-items-center text-center p-5 "
                    style={{ height: "80vh" }}
                  >
                    <img
                      src={PlaceholderDashboard}
                      className="w-25"
                      alt={`No Permission`}
                    />
                    <div className="w-50">
                      <p className="ff-sora font-size-16 fw-medium mt-4">
                        Permission Required!
                      </p>
                      <p className="ff-sora font-size-16 fw-normal">
                        Your account doesn’t currently have full access to the
                        Dashboard. Contact your administrator to update your
                        permissions.
                      </p>
                    </div>
                  </Card>
                </Col>
              )}
            </>
          )}
        </Row>
        {userPermissions?.user?.["Active User"] ||
        userPermissions?.user?.["Block User"] ||
        userPermissions?.user?.["Archive User"] ||
        userPermissions?.passes?.["View Pass"] ? (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              height: "50px",
              position: "sticky",
              bottom: "0",
              zIndex: "10",
            }}
          ></div>
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
